import { render, staticRenderFns } from "./PerObject.vue?vue&type=template&id=4ba88ca0&scoped=true"
import script from "./PerObject.vue?vue&type=script&lang=js"
export * from "./PerObject.vue?vue&type=script&lang=js"
import style0 from "./PerObject.vue?vue&type=style&index=0&id=4ba88ca0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba88ca0",
  null
  
)

export default component.exports